<select #create
        class="big"
        (input)="addFilter($any(create.value))"
        i18n-title title="Filter">
  <option class="unselected" i18n>{{ emoji }} filter</option>
  @for (g of allFilters(); track g.label) {
    @if (g.filters.length) {
      <optgroup [label]="g.label">
        @for (f of g.filters; track f.filter) {
          <option [value]="f.filter" [title]="f.title || ''">{{ f.label || f.filter }}</option>
        }
      </optgroup>
    }
  }
</select>
@for (filter of filters(); track $index; let i = $index) {
  <div class="controls" [title]="filter">
    <select id="filter-{{ i }}" [ngModel]="filter" (ngModelChange)="setFilter(i, switchFilter(filter, $event))" [title]="title(filter)">
      @for (g of allFilters(); track g.label) {
        @if (g.filters.length) {
          <optgroup [label]="g.label">
            @for (f of g.filters; track f.filter) {
              <option [value]="f.filter" [title]="f.title || ''">{{ f.label || f.filter }}</option>
            }
          </optgroup>
        }
      }
    </select>
    @if (negatable(filter)) {
      <button type="button" (click)="toggleQuery(i)">{{ store.account.querySymbol('!') }}</button>
    }
    <button type="button" (click)="removeFilter(i)" i18n>&ndash;</button>
  </div>
  @if (filter.startsWith('modified/') || filter.startsWith('response/') || filter.startsWith('published/') || filter.startsWith('created/')) {
    @if (store.hotkey() || relativeDate(dateValue(filter))) {
      <app-relative-date [value]="dateValue(filter)" (changed)="set(i, filter, $event)" />
    } @else {
      <input type="datetime-local"
             step="60"
             [value]="toDate(filter)"
             (focus)="focus()"
             (change)="hasFocus() && set(i, filter, toIso($any($event.target).value))"
             (keydown)="clearFocus() && $event.key === 'Enter' && set(i, filter, toIso($any($event.target).value)) || true"
             (blur)="set(i, filter, toIso($any($event.target).value))">
    }
  } @else if (parseValueFilter(filter)) {
    <app-value-filter [filter]="filter" [query]="rangeQuery()" (changed)="setValue(i, filter, $event)" />
  }
}
